import React, { memo } from 'react';
import styles from './style.module.css';
import Img from '../Img';

const Logo = ({ logoUrl }) => {
  if (logoUrl) {
    return (
      <div
        className={styles.logo_preview}
        style={{
          backgroundImage: `url(${logoUrl})`
        }}></div>
    );
  }
  return (
    <Img
      src="/logo.svg"
      className={styles.mobile_logo_size}
      alt="gupshup-logo"
      width="200"
      height="45"
      title="Gupshup"
    />
  );
};

export default memo(Logo);
